import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="erp-logo">
      <div className="logo-icon">
        <div className="logo-circle"></div>
        <div className="logo-letter">N</div>
      </div>
      <div className="logo-text">
        <span className="logo-erp">ERP</span>
        <span className="logo-nascimento">NASCIMENTO</span>
      </div>
    </div>
  );
};

export default Logo;
